import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import OrganizationFormFields from '@/pages/Organizations/components/OrganizationFormFields'
import SeparateLine from '@/shared/Forms/SeparateLine'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import organizationsApi from '@/pages/Organizations/organizations.api.ts'
import organizationsEvents from '@/pages/Organizations/events/organizations.events.ts'
import useInputFile from '@/shared/hooks/useInputFile.ts'
import filesUtils from '@/shared/Files/files.utils.ts'
import { useState } from 'react'

interface IProps {
  organization: IOrganization
  onCancel: () => void
}

const EditOrganizationSidePageContent = (props: IProps) => {
  const { wait: waitSave, loading: saveLoading } = useHttpLoader()
  const { wait: waitUpload, loading: uploadLoading } = useHttpLoader()
  const [lastUploadedFileName, setLastUploadedFileName] = useState<string>('')
  const [draft, _, handleChange] = useStateWithChange(props.organization)

  const handleImageUpload = (files: File[]) => {
    if (!files || files.length === 0) return

    const { errors, file } = filesUtils.validateFile(files[0], 5, ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'])

    if (errors.length > 0) {
      alert(`Файл "${file.name}" не загружен: ${errors.join(', ')}`)
      return
    }

    const preparedFile = filesUtils.fileWithUnixTimestamp(file)

    setLastUploadedFileName('')
    waitUpload(organizationsApi.uploadImage(props.organization.id, preparedFile), (resp) => {
      if (resp.status === 'success') {
        setLastUploadedFileName(resp.body.fileName || preparedFile.name)
      }
    })
  }

  const handleImageUploadClick = useInputFile({
    onFiles: handleImageUpload,
    multiple: false,
    accept: 'image/png, image/jpeg, image/jpg, image/webp',
  })

  const handleSave = () => {
    waitSave(
      organizationsApi.update(props.organization.id, {
        name: draft.name,
        contact: draft.contact,
        active: draft.active,
        tin: draft.tin,
      }),
      (resp) => {
        if (resp.status === 'success') {
          organizationsEvents.updated(resp.body)
          props.onCancel()
        }
      }
    )
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h4 className="text-heading-4">Редактирование организации</h4>
      <SeparateLine />
      <div className="flex-lines gap8">
        <div className="inline-flex-gap gap8 center">
          <Button
            size="default"
            type="default"
            text="Загрузить изображение"
            loading={uploadLoading}
            onClick={handleImageUploadClick}
          />
          {lastUploadedFileName && <span className="text-sm text-success">Загружено: {lastUploadedFileName}</span>}
        </div>
        <p className="text-sm text-secondary">PNG, JPG, JPEG, WEBP. До 5 МБ</p>
      </div>
      <OrganizationFormFields organization={draft} onChange={handleChange} />
      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8">
        <Button
          size="default"
          type="primary"
          text="Сохранить"
          loading={saveLoading}
          disabled={!draft.name}
          onClick={handleSave}
        />
        <Button size="default" type="default" text="Отмена" disabled={saveLoading} onClick={props.onCancel} />
      </div>
    </div>
  )
}

export default EditOrganizationSidePageContent
